import { useLoaderData } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { apiGetMostWinsWrestlerWomanListStats } from '../../../components/ui_components/ApiList';
import GeneralRenderingSpecificStats from '../../../components/MobileComponents/Stats/GeneralRenderingSpecificStats';


const MostWinsWrestlerFemaleMobile = () => {
    const wrestlersData = (useLoaderData() as any)?.['data'] ?? [];
    const [searchParams] = useSearchParams();
    const year = searchParams.get('year') || 'globale';

    return (
        <GeneralRenderingSpecificStats
            apiFunctionGetStats={apiGetMostWinsWrestlerWomanListStats}
            title="Vittorie"
            stat="wins_count"
            yearStart={year}
            wrestlerDataStart={wrestlersData}
        />
    );
};

export default MostWinsWrestlerFemaleMobile;